import styled from '@emotion/styled';
import { useResource, formatTime } from '@landsbankinn/l16n';
import type { Prismic } from '@landsbankinn/prismic';
import { Button, device, typography, theme } from '@landsbankinn/ui';
import format from 'date-fns/format';
import is from 'date-fns/locale/is';
import React from 'react';
import { ConsultationType } from '../../../../../__generated__/globalTypes';
import type { BookAppointment_bookAppointment_BookAppointmentPayload } from '../../../../graphql/Appointment/__generated__/BookAppointment';
import { useAppointmentContext, AppointmentStep } from '../../BookAppointment';
import { ImageContainer } from '../../shared/ImageContainer';
import { Title } from '../../shared/Title';
import res from './Success.res';

const Text = styled.p`
  ${typography.body}
  margin-bottom: 4px;
`;

const Bold = styled.strong`
  font-weight: bold;
`;

const StyledButton = styled(Button)`
  width: 100%;
`;

const StyledTitle = styled(Title)`
  margin-bottom: 20px;
`;

const DataContainer = styled.div`
  margin-bottom: 48px;

  @media ${device.tablet} {
    margin-bottom: 0px;
  }
`;

interface IProps {
  data?: BookAppointment_bookAppointment_BookAppointmentPayload;
  image?: Prismic.Image;
}

export function Success({ data, image }: IProps) {
  const { setCurrentStep, dispatch } = useAppointmentContext();
  const { r, locale } = useResource();

  return (
    <ImageContainer image={image} success>
      <DataContainer>
        <StyledTitle
          title={r(res.successTitle)}
          subTitle={r(
            data?.activityType === ConsultationType.Phonecall
              ? res.phoneCall
              : res.consultationAppointment,
          )}
        />
        {data?.activityType === ConsultationType.Appointment && (
          <Text>
            <Bold>{r(res.branch)}:</Bold> {data?.branch.name}
          </Text>
        )}
        <Text>
          <Bold>{r(res.type)}:</Bold> {data?.serviceName}
        </Text>
        <Text>
          <Bold>{r(res.date)}:</Bold>{' '}
          {data && format(new Date(data.startTime), 'd. LLLL', { locale: is })}
        </Text>
        <Text>
          <Bold>{r(res.time)}:</Bold>{' '}
          {formatTime(locale, new Date(data?.startTime))}
        </Text>
      </DataContainer>
      <StyledButton
        title={r(res.close)}
        bg={theme.colors.primary}
        onClick={() => {
          setCurrentStep?.(AppointmentStep.Intro);
          dispatch?.({
            type: 'setClearInfo',
          });
        }}
      />
    </ImageContainer>
  );
}
